import { ACTIVITY_TYPES } from '@shared/Resources/types';

export const STAFF_PAGE_TYPES = {
  INFORMATION: 'information',
};

export const TABS = [
  { type: STAFF_PAGE_TYPES.INFORMATION, title: 'User Information' },
];

export const NO_NAME = 'No Name';

export const USER_ACTIVITIES = [
  { value: 'All', label: 'All Activities' },
  { value: ACTIVITY_TYPES.ACTIVITY_PRACTICE, label: 'Practices' },
  { value: ACTIVITY_TYPES.ACTIVITY_LESSON, label: 'Lessons' },
  { value: ACTIVITY_TYPES.ACTIVITY_CHAT, label: 'Video chats' },
];

export const TOAST_TYPES = {
  SHOW_SUCCESS_CHANGED_LEVEL: 'SHOW_SUCCESS_CHANGED_LEVEL',
  SHOW_ERROR_CHANGED_LEVEL: 'SHOW_ERROR_CHANGED_LEVEL',
  SHOW_SUCCESS_ATTACHED: 'SHOW_SUCCESS_ATTACHED',
  SHOW_ERROR_ATTACHED: 'SHOW_ERROR_ATTACHED',
  SHOW_ERROR_ACTIVATE_USER_FIRST: 'SHOW_ERROR_ACTIVATE_USER_FIRST',
  SHOW_ERROR_MFA_USER_NOT_IN_COGNITO: 'SHOW_ERROR_MFA_USER_NOT_IN_COGNITO',
  SHOW_ERROR_MFA_PHONE_REQUIRED: 'SHOW_ERROR_MFA_PHONE_REQUIRED',
  SHOW_SUCCESS_PASSWORD_RESET: 'SHOW_SUCCESS_PASSWORD_RESET',
  SHOW_ERROR_PASSWORD_RESET: 'SHOW_ERROR_PASSWORD_RESET',
  SHOW_SUCCESS_MFA_UPDATED: 'SHOW_SUCCESS_MFA_UPDATED',
  SHOW_ERROR_MFA_UPDATED: 'SHOW_ERROR_MFA_UPDATED',
  SHOW_SUCCESS_PHONE_UPDATED: 'SHOW_SUCCESS_PHONE_UPDATED',
  SHOW_ERROR_PHONE_UPDATED: 'SHOW_ERROR_PHONE_UPDATED',
  SHOW_ERROR_PHONE_USER_NOT_IN_COGNITO: 'SHOW_ERROR_PHONE_USER_NOT_IN_COGNITO',
  SHOW_ERROR_REMOVE_PHONE_SMS_MFA: 'SHOW_ERROR_REMOVE_PHONE_SMS_MFA',
  SHOW_SUCCESS_UPDATED: 'SHOW_SUCCESS_UPDATED',
};

// Backend blockedReason values (GraphQL admin actions)
export const AUTH_BLOCKED_REASONS = {
  USER_INACTIVE: 'USER_INACTIVE',
  USER_NOT_IN_COGNITO: 'USER_NOT_IN_COGNITO',
  PHONE_NUMBER_REQUIRED: 'PHONE_NUMBER_REQUIRED',
  SMS_MFA_ENABLED: 'SMS_MFA_ENABLED',
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const LANGUAGES = {
  HEBREW: 'HEBREW',
  ENGLISH: 'ENGLISH',
};
